import { useState } from 'react';

import EmailLeadForm from '~components/LeadForm/EmailLeadForm/EmailLeadForm';
import success from '~images/common/circle-green-checkmark.svg';

type Props = {
    cta: string;
    formheader: string;
    uid: string;
};

const EnrollmentEnrollReminder = ({
    cta = 'Remind Me',
    formheader = 'Under 65? Get Your Enrollment Reminder',
    uid,
}: Props) => {
    const [isSuccess, setIsSuccess] = useState(false);

    return (
        <div className="max-w-80 mx-auto">
            <p aria-live="polite" className="sr-only">
                {isSuccess && 'Success! Your enrollment reminder has been sent.'}
            </p>
            <h4 className="text-2xl font-bold mb-8 text-center font-poppins">{formheader}</h4>
            <p className="text-lg text-center lg:text-[27px] leading-27">
                Don&apos;t miss your initial enrollment&nbsp;period!
            </p>
            {!isSuccess ? (
                <div className="my-6">
                    <EmailLeadForm
                        buttonText={cta}
                        isStacked={true}
                        leadInfo={{ advertiseSource: 'NTMRemind' }}
                        leadTrackingAction={{ page: { action: 'enrollment-reminder' } }}
                        mktoFormId={1006}
                        onSuccess={() => setIsSuccess(true)}
                        uid={uid}
                        useBirthdate={true}
                    />
                </div>
            ) : (
                <div>
                    <h3 className="flex justify-center items-center text-center text-2xl font-bold mb-2 mt-4">
                        <img
                            src={success}
                            className="pr-2"
                            height="24"
                            width="32"
                            alt="green check mark"
                        />
                        <span>Success!</span>
                    </h3>
                    <p className="text-center">Your enrollment reminder has been sent!</p>
                </div>
            )}
        </div>
    );
};

export default EnrollmentEnrollReminder;
